import { notification } from "antd";
import Axios from "axios";

let cachedCoinsListMemory = null;

export const normalizeVsCurrency = (currency = "INR") => {
    const lower = String(currency || "inr")
        .trim()
        .toLowerCase();
    return lower === "usdt" ? "usd" : lower;
};

export const getCoinInfo = async (assets, currency = "INR") => {
    try {
        if (!assets || assets.length === 0) {
            return [];
        }
        const ids = assets.map((asset) => asset.id).join(",");
        const vsCurrency = normalizeVsCurrency(currency);
        const api = `${process.env.REACT_APP_API}/coin-gecko/market-data?ids=${ids}&currency=${vsCurrency}`;
        const response = await Axios.get(api, {
            withCredentials: true,
        });
        return Array.isArray(response.data) ? response.data : [];
    } catch (e) {
        notification.error({
            message: `Failed to fetch market data, try again in sometime`,
        });
        return [];
    }
};

export const getCoinsList = async () => {
    if (
        Array.isArray(cachedCoinsListMemory) &&
        cachedCoinsListMemory.length > 0
    ) {
        return cachedCoinsListMemory;
    }
    try {
        const api = `${process.env.REACT_APP_API}/coin-gecko/list-coins`;
        const response = await Axios.get(api, {
            withCredentials: true,
        });
        if (Array.isArray(response.data) && response.data.length > 0) {
            cachedCoinsListMemory = response.data;
            return response.data;
        }
        return [];
    } catch (e) {
        notification.error({
            message: `Failed to fetch all coins from server, try after sometime`,
        });
        return [];
    }
};
